<template>
	<v-dialog v-model="setdialog.dialog" :width="nowWidth < 600 ? '90%' : '500px'" persistent content-class="mx-2 reservedayViewport">
		<div class="exitVisitBtn" :style="`max-width:${nowWidth < 600 ? '90%' : '500px'};`" v-show="!setdialog.step2 && !setdialog.step3">
			<v-btn icon @click="exitSurvey" v-show="$route.name !== 'reserve_waiting'">
				<v-icon size="35px" color="white">
					mdi-close-circle
				</v-icon>
			</v-btn>
		</div>
		<!-- 기존 예약 확인 -->
		<v-card class="dialogDays" v-if="setdialog.step2">
			<div class="dialog-content1">
				<div class="infoCard">
					<div style="border-bottom: 3px dashed #E8E8E8">
						<v-layout justify-center>
							<div class="infoBackground" :style="`background-color:${$store.state.PointColor7}`">
								<v-icon size="40px" color="white">mdi-check </v-icon>
							</div>
						</v-layout>
						<p class="surveyNameres">
							[{{ $store.state.reserveUserData.name ? $store.state.reserveUserData.name : setdialog.inputUserData.name }}]고객님
							상담신청정보를 확인하세요.
						</p>
					</div>
					<div>
						<div class="infoText" v-if="$store.state.reserveUserData.name">
							고객명
							<span class="infoTextValue">{{ $store.state.reserveUserData.name }} </span>
						</div>
						<div class="infoText" v-else>
							고객명
							<span class="infoTextValue">{{ setdialog.inputUserData.name }} </span>
						</div>
						<div class="infoText" v-show="$route.name === 'reserve_waiting'">
							대기번호
							<span class="infoTextValue" style="color:#4C428C">{{ waitNum }}번</span>
						</div>
						<div class="infoText mb-4" v-show="$route.name === 'reserve_waiting'">
							대기팀
							<span class="infoTextValue" style="color:#4C428C">{{ waitLength }}팀</span>
						</div>
					</div>
				</div>
				<div class="springNote"></div>
				<p class="lastInfoRes">
					* 상담신청 확인을 위한 알림톡이 발송되었습니다.
				</p>
				<p class="lastInfoRes">
					상담 호출 시 현장에 안 계실 경우 상담예약이 취소될 수 있으니 카카오톡을 수시로 확인 바랍니다.
				</p>
				<!-- bottom -->
				<div class="bottom2 mt-6">
					<v-layout flex-wrap>
						<v-flex xs12 class="mb-4">
							<btn
								btn_txt="확인"
								:style="`background-color:${$store.state.PointColor7}; color:${$store.state.PointColor8}; border-radius: 0px; `"
								:btn="doneBtn"
								@click="clickdoneBtn"
							></btn>
						</v-flex>
					</v-layout>
				</div>
			</div>
		</v-card>
		<div id="createWaiting" @click="createWaiting()"></div>
		<!-- 예약 완료 화면 -->
		<alertModal5 :setdialog="alertModal" />
		<alertModal5 :setdialog="alertModal2" />
		<previewEventTalk :setdialog="previewEventTalk" />
	</v-dialog>
</template>

<script>
import { alertModal5, btn } from '@/components/index'
import previewEventTalk from './previewEventTalk'
export default {
	components: {
		btn,
		alertModal5,
		previewEventTalk,
	},
	props: {
		reservedaysData: Object,
		setdialog: Object,
		title: String,
		tab: Object,
		// noInputBox: Boolean,
	},
	data() {
		return {
			endBtn: false,
			previewEventTalk: {
				dialog: false,
				modalIcon: 'success',
				title: '',
				content: '',
			},
			imgFiles: [],
			giftBox: {
				dialog: false,
				color: 'black',
				titleColor: 'white',
				title: 'test',
				product: '',
				winnerMessage: '',
				joinMessage: '',
			},
			recentPhone: '', // 연속 waiting 생성 방지 data
			// --- date picker --
			picker: { date: '', allowedDates: '2021-5-30' },
			// --- 시간 선택 버튼 ---
			timeData: [],
			selectedTime: '',
			// --- 버튼 ---
			cancelBtn: {
				class: 'cancel',
			},
			saveBtn: {
				class: 'customBtn',
				width: '100%',
			},
			closeBtn: {
				block: true,
				large: true,
				class: 'selectBtn',
			},
			doneBtn: {
				class: 'customBtn',
				dark: false,
				block: true,
				disabled: true,
			},
			reseveCancel: {
				class: 'selectBtn',
				block: true,
			},
			reserveChange: {
				class: 'customBtn',
				dark: true,
				block: true,
			},
			alertModal: {
				dialog: false,
				text: '표시된 필수 입력 부분을 모두 입력해주세요.',
				reddot: true,
			},
			alertModal2: {
				dialog: false,
				text: '',
			},
			okaySetDialog: {
				dialog: false,
				text: '',
				title: '완료',
			}, // 캠페인 완료 후 나오는 모달
			// --- 캠페인 명 ---
			campaignName: 'TEST CAMPAIGN MODELHOUSE',
			reserveChangeOn: false,
			message: '',
			messageData1: {}, // create / update 알림톡 데이터
			messageData2: {}, // delete 알림톡 데이터
			messageData3: {},
			messageData4: {}, // 내가 받을 알림톡 데이터
			messageData5: {}, // 내가 받을 알림톡 취소시 데이터
			messageData6: {}, // 현장 방문등록
			length: {},

			// 오늘 대기 번호
			waitNum: '',
			/// 대기자 수
			waitLength: '',
			// 예약률
			percent: '',

			screenWidth: window.innerWidth,
			reserveNum: '', // 방문등록 대기번호
			reserveLength: '', // 방문등록 대기자수
		}
	},
	computed: {
		nowWidth() {
			window.addEventListener('resize', () => {
				this.screenWidth = window.innerWidth
			})
			return this.screenWidth
		},
	},
	methods: {
		isMobile() {
			const ua = navigator.userAgent
			if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(ua)) {
				return 'tablet'
			} else if (/Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(ua)) {
				return 'mobile'
			}
			return 'desktop'
		},
		clickdoneBtn() {
			this.setdialog.step2 = false
			this.setdialog.dialog = false

			window.open('about:blank', '_self').close()
			if (this.isMobile() !== 'desktop') {
				location.href = 'kakaotalk://inappbrowser/close'
			}
		},
		nowTime() {
			/// 현재시간
			let a = new Date()
			let b = this.$moment(a).format('YYYY년 MM월 DD일')
			let c = this.$moment(a).format('hh:mm')
			var nowHour = a.getHours()
			let jeonhoo = ''
			if (nowHour < 12 && nowHour >= 0) {
				jeonhoo = ' 오전 '
			} else {
				jeonhoo = ' 오후 '
			} //12시 이전일 때 오전, 나머지 오후
			return b + jeonhoo + c
		},
		createWaiting() {
			this.recentPhone = this.setdialog.inputUserData.phone
			const datas = {
				inputBoxTitle: this.reservedaysData.input_box.name,
				name: this.setdialog.inputUserData.name,
				phone: this.setdialog.inputUserData.phone,

				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				ismarketing: 2,
				ispersonal: 1,
				cdate: this.$moment(new Date()).add(9, 'hour'),
				date: this.$moment(new Date()).add(9, 'hour'),
				stat: 0,
				rdate: this.$moment(new Date()).add(9, 'hour'),
				title: this.reservedaysData.title,
				seat: 0, // 상담석으로 가기전의 대기 상태 부여 => seat = 0
				business: Number(this.reservedaysData.business.id),
				marketing: false,
			}
			this.$store
				.dispatch('createWaiting', datas)
				.then(resWaiting => {
					this.$store
						.dispatch('waitings', { id: resWaiting.data.createWaiting.waiting.id, code: resWaiting.data.createWaiting.waiting.code })
						.then(res => {
							this.waitNum = res.data.waitings[0].waitingnum
							this.$store
								.dispatch('waitingsConnection', {
									code: this.$route.params.code,
									// stat: 0,
									seat: 0,
									csdate: this.$moment().format('YYYY-MM-DD') + 'T00:00:00.000Z',
									cedate:
										this.$moment()
											.add(1, 'days')
											.format('YYYY-MM-DD') + 'T00:00:00.000Z',
									stat: 0,
								})
								.then(res => {
									const waitingsPeople = res.data.waitingsConnection.aggregate.count
									this.waitLength = waitingsPeople - 1
									this.setdialog.step2 = true
									this.$store.state.loading = false
									this.$store.dispatch('messages', {}).then(res => {
										// create / update 알림톡 tplCode messages 에서 찾기 -> reserveday tplCode 에서 index 0
										let foundIndex1 = res.data.messages.findIndex(obj => {
											return obj.tplCode === this.$store.state.reservedayData.tplCode[0]
										})
										// delete 알림톡 tplCode messages 에서 찾기 -> reserveday tplCode 에서 index 2
										let foundIndex2 = res.data.messages.findIndex(obj => {
											return obj.tplCode === this.$store.state.reservedayData.tplCode[2]
										})
										let foundIndex3 = res.data.messages.findIndex(obj => {
											return obj.tplCode === this.$store.state.reservedayData.tplCode[3]
										})
										let foundIndex4 = res.data.messages.findIndex(obj => {
											return obj.tplCode === this.$store.state.reservedayData.tplCode[12]
										})
										let foundIndex5 = res.data.messages.findIndex(obj => {
											return obj.tplCode === this.$store.state.reservedayData.tplCode[13]
										})
										if (foundIndex1 !== -1) {
											this.messageData1 = res.data.messages[foundIndex1] // create / update 알림톡 데이터
										}
										if (foundIndex2 !== -1) {
											this.messageData2 = res.data.messages[foundIndex2] // delete 알림톡 데이터
										}
										if (foundIndex3 !== -1) {
											this.messageData3 = res.data.messages[foundIndex3] // delete 알림톡 데이터
										}
										if (foundIndex4 !== -1) {
											this.messageData4 = res.data.messages[foundIndex4] // 내가 받을 알림톡 알림톡 데이터
										}
										if (foundIndex5 !== -1) {
											this.messageData5 = res.data.messages[foundIndex5] // 내가 받을 알림톡 알림톡 데이터
										}
										this.sendMessageForDirect(resWaiting.data.createWaiting.waiting)
									})
								})
						})

					// this.$socket.emit('reservation', { code: datas.code })
					// this.$socket.emit('reservationBoardList', { code: datas.code })
				})
				.catch(() => {
					alert('일시적인오류가 발생하였습니다. 새로고침 후 다시 신청해 주세요.')
					this.$store.state.loading = false
				})
		},
		sendMessageForDirect(userdata) {
			const rdate = this.$moment(userdata.rdate)
				.subtract('hours', 9)
				.format('YYYY년 MM월 DD일 HH:mm')
			let url = `${location.protocol}//${location.hostname}/waitingCheck/${this.$route.params.code}/${this.setdialog.inputUserData.phone}`
			if (this.messageData3.message === undefined) {
				// 생성 / 수정시 알림톡 tpl_code가 없는 경우
				return
			} else {
				this.messageData3.message = this.messageData3.message.replace(/#{사업지명}/g, this.$store.state.reservedayData.title)
				this.messageData3.message = this.messageData3.message.replace(/#{고객명}/g, this.setdialog.inputUserData.name)
				this.messageData3.message = this.messageData3.message.replace(/#{상담신청일시}/g, rdate)
				this.messageData3.message = this.messageData3.message.replace(/#{상담 신청일시}/g, rdate)
				this.messageData3.message = this.messageData3.message.replace(/#{관람신청일시}/g, rdate)
				this.messageData3.message = this.messageData3.message.replace(/#{대기번호}/g, this.waitNum)
				this.messageData3.message = this.messageData3.message.replace(/#{대기번호1}/g, this.waitNum)
				this.messageData3.message = this.messageData3.message.replace(/#{대기번호2}/g, this.waitNum)
				this.messageData3.message = this.messageData3.message.replace(/#{대기자수}/g, this.waitLength)
				this.messageData3.message = this.messageData3.message.replace(/#{대기정보}/g, url)
			}
			if (this.messageData3.button) {
				const buttonsData = JSON.parse(this.messageData3.button).button
				buttonsData.forEach(element => {
					element.linkMo = element.linkMo.replace(/#{그룹}/g, this.$route.params.code)
					element.linkPc = element.linkPc.replace(/#{그룹}/g, this.$route.params.code)
					element.linkMo = element.linkMo.replace(/#{코드}/g, this.$route.params.code)
					element.linkPc = element.linkPc.replace(/#{코드}/g, this.$route.params.code)
					element.linkMo = element.linkMo.replace(/#{전화번호}/g, this.setdialog.inputUserData.phone)
					element.linkPc = element.linkPc.replace(/#{전화번호}/g, this.setdialog.inputUserData.phone)
					element.linkMo = element.linkMo.replace(/#{상담ID}/g, this.setdialog.inputUserData.phone)
					element.linkPc = element.linkPc.replace(/#{상담ID}/g, this.setdialog.inputUserData.phone)
					element.linkMo = element.linkMo.replace(/#{방문ID}/g, this.setdialog.inputUserData.phone)
					element.linkPc = element.linkPc.replace(/#{방문ID}/g, this.setdialog.inputUserData.phone)
					element.linkMo = element.linkMo.replace(
						/#{분양정보pdf}/g,
						this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
					)
					element.linkPc = element.linkPc.replace(
						/#{분양정보pdf}/g,
						this.reservedaysData.business.alertTalkSalesInformation?.url.replace('/uploads/', ''),
					)
					if (this.reservedaysData.business.alertTalkSubscriptionInformation?.url) {
						element.linkMo = element.linkMo.replace(
							/#{청약안내pdf}/g,
							this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
						)
						element.linkPc = element.linkPc.replace(
							/#{청약안내pdf}/g,
							this.reservedaysData.business.alertTalkSubscriptionInformation?.url.replace('/uploads/', ''),
						)
					}
					element.linkMo = element.linkMo.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
					element.linkPc = element.linkPc.replace(/#{사업지명}/g, this.reservedaysData.business.alertTalkTalk)
					element.linkMo = element.linkMo.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
					element.linkPc = element.linkPc.replace(/#{url}/g, this.reservedaysData.business.alertTalkHomepage)
				})
				this.messageData3.button = JSON.stringify(buttonsData)
			}
			const data = {
				// 필수값

				code: this.$route.params.code ? this.$route.params.code : process.env.VUE_APP_SAMPLE_CODE,
				sender: this.messageData3.smssender,
				senderkey: this.messageData3.senderkey,
				tpl_code: this.messageData3.tplCode,
				receiver_1: this.setdialog.inputUserData.phone,
				subject_1: this.messageData3.tplCodeStr,
				message_1: this.messageData3.message,
				// 여기까지 필수값
				// apikey: this.$store.state.apikey,
				// userid: this.$store.state.userid,
				recvname_1: this.setdialog.inputUserData.name,
				failover: 'Y',
				fsubject_1: this.messageData3.tplCodeStr,
				fmessage_1: this.messageData3.message,
				button_1: this.messageData3.button ? this.messageData3.button : '[]',
				pay: this.reservedaysData.business?.id,
			}
			this.$store.dispatch('createSendMessage', data).then(() => {})
		},
		exitSurvey() {
			this.setdialog.dialog = false
			setTimeout(() => {
				this.setdialog.step2 = false
			}, 500)
		},
	},
}
</script>

<style lang="scss">
.vieport_headTxt {
	width: 100%;
	max-width: 320px;
	margin: 31px 0px 17px;
	color: #636363;
	font-size: 16px;
	font-weight: bold;
}
.reservedayViewport {
	max-height: 84% !important;
	// overflow: hidden !important;
	overflow: auto;
}

.dialogDays {
	.title {
		height: 60px;
		display: flex;
		align-items: center;
		background-color: #fdc85a;
		padding: 0 25px;

		h2 {
			color: white;
		}

		.title-icon {
			color: white;
		}
	}

	.dialog-content {
		padding: 10px;
		.divider-dark {
			background-color: black;
		}

		.dialog-left {
			max-width: 200px;
			padding: 20px 25px;
			text-align: right;

			.dialog-star {
				color: red;
				margin-left: 8px;
				width: 8px;
			}
		}

		.dialog-right {
			padding: 20px 25px;
		}
	}
	.dialog-content1 {
		padding: 16px;
		.infoCard {
			padding: 16px;
			box-shadow: 0px 18px 11px 4px lightgrey;
			.infoBackground {
				display: flex;
				justify-content: center;
				align-items: center;
				border-radius: 50%;
				min-width: 90px;
				min-height: 90px;
				margin-bottom: 10px;
				.infoYear {
					background-color: white;
					color: black;
					font-size: 14px;
					border-radius: 10px 10px 0px 0px;
				}
				.infoHour {
					font-size: 14px;
					font-weight: 100;
				}
			}
			.infoText {
				display: flex;
				margin-top: 12px;
				font-size: 16px;
				font-weight: 500;
				color: #656565;
				.infoTextValue {
					margin-left: auto;
				}
			}
		}
		.springNote {
			height: 20px;
			background: radial-gradient(ellipse at bottom, transparent 53%, white 53%);
			background-size: 33px 40px;
			margin-bottom: 25px;
		}
	}
	.bottom {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
	.bottom2 {
		display: flex;
		justify-content: center;
		margin-top: 20px;
	}
}

.dateGuideDay {
	font-size: 80%;
	font-weight: bold;
}
.contentName {
	font-size: 16px;
	font-weight: bold;
	margin-bottom: 5px !important;
}
.v-btn--rounded {
	border-radius: 0;
}
.smallLabel {
	margin-top: 5px;
	.v-label {
		font-size: 14px !important;
		color: #a6a6a6 !important;
	}
}
.allAgree {
	margin-top: 5px;
	.v-label {
		font-size: 14px;
		font-weight: bold;
		color: #a6a6a6 !important;
	}
}
.layout {
	margin: 0px 0px 0px 0px !important;
}
.resCheck {
	font-size: 14px;
	font-weight: bold;
}
.infoCheck {
	color: #2a3c48;
	font-weight: bold;
	font-size: 16px;
	span {
		color: white;
		background-color: #2a3c48;
		padding: 5px 10px 5px 10px;
		font-size: 12px;
		border-radius: 5px;
		margin-right: 7px;
	}
}
.lastInfo {
	font-size: 14px;
	color: #4b4948;
	margin-bottom: 0px !important;
}
.place-title-strong {
	font-weight: bold !important;
	color: #006b8f;
}
.surveyNameres {
	text-align: center;
	font-size: 17px;
	font-weight: bold;
	margin: 16px 0px !important;
}
.resinfoCheck {
	color: #2a3c48;
	font-weight: 500;
	font-size: 14px;
	span {
		color: white;
		background-color: #2a3c48;
		padding: 5px 10px 5px 10px;
		font-size: 12px;
		border-radius: 5px;
		margin-right: 7px;
	}
}
.lastInfoRes {
	white-space: pre-line;
	font-size: 15px;
	font-weight: 500;
	color: #656565;
	margin-bottom: 0px !important;
}
</style>
